/**
 * Bridge no-React para que helpers (p. ej. toLocalDateStringYMD) lean la fecha
 * operativa de sesión sin depender de Context.
 */
export type FechaOperativaSnapshot = {
  /** YYYY-MM-DD; null = usar reloj real */
  ymd: string | null;
};

export const FECHA_OPERATIVA_STORAGE_PREFIX = 'eone.fechaOperativa';

let snapshot: FechaOperativaSnapshot = { ymd: null };

export const getFechaOperativaSnapshot = (): FechaOperativaSnapshot => snapshot;

export const setFechaOperativaSnapshot = (next: FechaOperativaSnapshot): void => {
  snapshot = { ymd: next.ymd };
};

/** Limpia override en memoria y todas las claves de sessionStorage (logout). */
export const clearFechaOperativaSession = (): void => {
  snapshot = { ymd: null };
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(FECHA_OPERATIVA_STORAGE_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // sessionStorage no disponible
  }
};

/** Date efectiva para defaults de documentos (fecha operativa o ahora). */
export const getFechaOperativaDate = (): Date => {
  if (!snapshot.ymd || !/^\d{4}-\d{2}-\d{2}$/.test(snapshot.ymd)) {
    return new Date();
  }
  const [y, m, d] = snapshot.ymd.split('-').map(Number);
  // Mediodía local evita corrimientos de día por zona horaria.
  return new Date(y, m - 1, d, 12, 0, 0, 0);
};
